<template>
	<div>
		<v-card flat class="pa-1">
			<v-toolbar flat color="#FFF" short>
				<v-toolbar-title>Controle de Permissões</v-toolbar-title>
			</v-toolbar>
			<v-tabs centered>
				<v-tab>
					<v-icon left>mdi-account-details</v-icon>
					Permissôes
				</v-tab>
				<v-tab-item class="ma-0">
					<v-card flat>
						<v-card-text class="pa-0">
							<permissoes/>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs>
		</v-card>
	</div>
</template>

<script>
import Permissoes from './Permissoes'

export default {

    components: { Permissoes },

    data(){
        return {

        }
    }
};
</script>

<style>
</style>